// Keep zero distinct from a missing or malformed job ID.
export function parseJigTransferJobId(value: unknown): number | null {
  if (typeof value === 'string') {
    if (!value || /\D/.test(value)) return null
    value = Number(value)
  }
  return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 ? value : null
}
